export default __webpack_public_path__ + "static/media/Velocity-Home_13.8eb5ffe2.jpg";